import React from "react";
import "./Background.scss";

function Background() {
  return <div className="container-fuild background" />;
}
export default Background;
